import { render, staticRenderFns } from "./AddProvider.vue?vue&type=template&id=1802348b&"
import script from "./AddProvider.vue?vue&type=script&lang=js&"
export * from "./AddProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports